module.exports = __webpack_public_path__ + "img/4.a.d93387fb.png";